import React from 'react';
import CustomPrimaryButton from '../../shared/components/CustomPrimaryButton';
import RedirectInfo from '../../shared/components/RedirectInfo';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';



const RegistrationPageFooter = ({ handleRegister, isFormValid }) => {
    const navigate=useNavigate();
    const handlePushToLogin=()=>{
   navigate("/login")

    }
    const getFormNotValidMessage=()=>{
        return "Введите username, корректный e-mail и пароль от 5 до 11 символов"
    
    }
    const getFormValidMessage=()=>{
        return "Нажмите, чтобы зарегистрироваться";
    }
	return (
        <>
        <Tooltip title={!isFormValid ? getFormNotValidMessage() : getFormValidMessage()}>
		<div>
			<CustomPrimaryButton
				label='Зарегистрироваться'
				additionalStyles={{ marginTop: '30px' }}
				disabled={!isFormValid}
				onClick={handleRegister}
			/>
		</div>
        </Tooltip>
        <RedirectInfo text="" redirectText="Уже есть аккаунт?" additionalStyles={{marginTop:"5px"}} redirectHandler={handlePushToLogin} />
        </>
	);
};

export default RegistrationPageFooter;
